module.exports = __webpack_public_path__ + "media/images/emblems/Matzingen-coat_of_arms-db24ea7edb979e35cc34a20aaab9357a.svg";